<mat-form-field class="full-width">
  <mat-label>{{label}}</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="formControl">
    <mat-hint>DD/MM/YYYY</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if(errorMessage){
      <mat-error>
        {{ errorMessage }}
      </mat-error>
    }
</mat-form-field>
